'use client';

export const SORT_OPTIONS = [
  { id: 'featured', label: 'Featured' },
  { id: 'price-asc', label: 'Price: Low to High' },
  { id: 'price-desc', label: 'Price: High to Low' },
  { id: 'title-asc', label: 'Alphabetical: A–Z' },
  { id: 'newest', label: 'Newest' },
] as const;

export type SortId = typeof SORT_OPTIONS[number]['id'];

export default function SortSelect({
  value,
  onChange,
}: {
  value: SortId;
  onChange: (v: SortId) => void;
}) {
  return (
    <label className="sort">
      <span className="sort-label">Sort:</span>
      <select
        className="sort-select"
        value={value}
        onChange={(e) => onChange(e.target.value as SortId)}
      >
        {SORT_OPTIONS.map((o) => (
          <option key={o.id} value={o.id}>{o.label}</option>
        ))}
      </select>

      <style>{`
        .sort {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 0.85rem;
          color: var(--color-text-secondary);
          white-space: nowrap;
        }
        .sort-label {
          font-weight: 600;
          color: var(--color-text-primary);
        }
        .sort-select {
          font-family: inherit;
          font-size: 0.85rem;
          font-weight: 500;
          color: var(--color-text-primary);
          background: var(--color-white);
          border: 1px solid var(--color-border);
          border-radius: 0.5rem;
          padding: 0.45rem 2rem 0.45rem 0.75rem;
          appearance: none;
          background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%231b3f23' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'><path d='m6 9 6 6 6-6'/></svg>");
          background-repeat: no-repeat;
          background-position: right 0.55rem center;
          cursor: pointer;
        }
        .sort-select:focus {
          outline: none;
          border-color: var(--color-primary);
          box-shadow: 0 0 0 3px rgba(27,63,35,0.12);
        }
      `}</style>
    </label>
  );
}
